<template>
  <router-link class="card__link" :to="{ name: 'project', params: { id: project.id } }">
    <card class="card--project"
      :horizontal="horizontal"
      :card-color="cardColor"
      :text-color="textColor"
      :accent-color="accentColor"
      :border-color="borderColor"
      :class="{ active: project.status && project.status.toLowerCase() === 'in-progress' }">
      <template v-slot:media v-if="toBase(project.image || placeholderImage)">
        <img
          class="card--project__image"
          :src="toBase(project.image || placeholderImage)"
          :alt="'Image ' + project.title" />
      </template>
      <template v-slot:header>
        <h6 class="card--project__title">{{ project.title }}</h6>
      </template>
      <template v-slot:body>
        <p class="card--project__text">{{ project.short }}</p>
      </template>
    </card>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

import Card from '@/components/Card'

export default {

  name: 'project-card',

  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    cardColor: {
      type: String,
      default: '#ffffff'
    },
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String,
      default: '#ffffff'
    },
    project: {
      type: Object,
      default: () => ({
        'title': 'Project Title',
        'short': 'Short description about the project',
        'description': 'Long html description about the project',
        'image': undefined,
        'participants': [
          'John Doe'
        ],
        'start': '2000-01-01',
        'end': '2000-01-01',
        'category': [],
        'status': 'completed'
      })
    },
    placeholderImage: {
      type: String,
      default: '/static/img/project.png'
    }
  },

  components: {
    'card': Card
  },

  computed: {
    ...mapGetters(['toBase'])
  }
}
</script>

<style lang="scss" scoped>

.card__link {
  display: flex;
  text-decoration: none;
  width: 100%;
}

.card--project {

  &__title {
    font-size: 1.3rem;
    color: var(--text-color);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectCard.vue